/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Maintenance_LabelInputs */

const tr_mesafeli_s12_maintenance_label = /** @type {(inputs: Mesafeli_S12_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlı bakım:`)
};

const en_mesafeli_s12_maintenance_label = /** @type {(inputs: Mesafeli_S12_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned maintenance:`)
};

const de_mesafeli_s12_maintenance_label = /** @type {(inputs: Mesafeli_S12_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplante Wartung:`)
};

const ru_mesafeli_s12_maintenance_label = /** @type {(inputs: Mesafeli_S12_Maintenance_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плановые работы:`)
};

/**
* | output |
* | --- |
* | "Planned maintenance:" |
*
* @param {Mesafeli_S12_Maintenance_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_maintenance_label = /** @type {((inputs?: Mesafeli_S12_Maintenance_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Maintenance_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_maintenance_label(inputs)
	if (locale === "de") return de_mesafeli_s12_maintenance_label(inputs)
	if (locale === "ru") return ru_mesafeli_s12_maintenance_label(inputs)
	return tr_mesafeli_s12_maintenance_label(inputs)
});